module.exports = __webpack_public_path__ + "img/Heycar_Andre Vella_Former Chief.484a6593.png";